/**
 * Permission catalogue. Names follow the CLIRNET backend's "verb resource"
 * style and are checked per tenant with its /permissionverfy endpoint (see
 * server/authApi.js). docs/PERMISSIONS.md lists what each unlocks.
 *
 * Access rule: a page (tab, content details page, user page) needs its page
 * permission; a card on it may need one more, only when it shows demographic
 * (`audience`) or person-level (`users`) data. Cards without access are left
 * out of the API response entirely.
 */

export const P = {
  acquisition: "view analytics acquisition",
  campaigns: "view analytics campaigns",
  audience: "view analytics audience",
  contentOverview: "view analytics content overview",
  videos: "view analytics videos",
  medwiki: "view analytics medwiki",
  webinars: "view analytics webinars",
  courses: "view analytics courses",
  surveys: "view analytics surveys",
  ebooks: "view analytics ebooks",
  channels: "view analytics channels",
  users: "view analytics users",
  pii: "view analytics pii",
  monitoring: "view analytics monitoring",
  export: "export analytics",
};

export const ALL_PERMISSIONS = Object.values(P);

/** Page permission of each content type's tab and details pages. */
export const TYPE_PERMISSION = {
  video: P.videos,
  // Reels and series are videos: the backend has no permission of their own, so the video one opens them.
  reels: P.videos,
  series: P.videos,
  medwiki: P.medwiki,
  session: P.webinars,
  training: P.courses,
  survey: P.surveys,
  epub: P.ebooks,
  channel: P.channels,
};

/** Permissions that open at least one page; a tenant without any of them is not offered. */
export const PAGE_PERMISSIONS = [
  P.acquisition,
  P.campaigns,
  P.audience,
  P.contentOverview,
  ...Object.values(TYPE_PERMISSION),
  P.users,
  P.monitoring,
];
